export default "__VITE_ASSET__Bb2O6F8E__"